import Image from 'next/image';
import { Anchor, Box, Button, Heading, List, Paragraph } from '@zillow/constellation-10';
import { APPLICATIONS_FAQ_URL, EXTERNAL_URLS, getExternalUrl } from '../../constants/urls';
import { RENTAL_APPLICATION_PRICE } from '../../constants/applicationsConstants';
import NoApplicationsImage from '../../images/no_applications_img.png';

export function ApplicationsEmptyState() {
  return (
    <>
      <Image
        alt="Two friends on a computer"
        src={NoApplicationsImage}
        sizes="100vw"
        style={{
          width: '100%',
          height: 'auto',
        }}
      />
      <Box
        css={{
          paddingTop: 'sm',
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)',
          gap: 'md',
          alignContent: 'start',
        }}
      >
        <Box
          css={{
            display: 'grid',
            gridColumnEnd: { base: 'span 12', lg: 'span 6' },
          }}
        >
          <Box>
            <Heading level={3} textStyle="responsive.heading-md">
              Find a rental you love
            </Heading>
            <Paragraph css={{ marginTop: 'sm' }}>
              Browse and apply for rentals - all in one place. With Zillow applications you’re one step closer to
              finding your new home.
            </Paragraph>
          </Box>
        </Box>
        <Box
          css={{
            display: 'grid',
            gridColumnEnd: { base: 'span 12', lg: 'span 6' },
          }}
        >
          <List.Root appearance="bullet" css={{ marginBottom: 'sm' }}>
            <List.Item>
              <strong>Save</strong> time and avoid multiple fees with one application, one payment.
            </List.Item>
            <List.Item>
              <strong>View</strong> your credit and background check before submitting.
            </List.Item>
            <List.Item>
              <strong>Apply</strong> to as many participating Zillow listings as you’d like - just{' '}
              {RENTAL_APPLICATION_PRICE} for 30 days.
            </List.Item>
            <List.Item>
              Questions? <Anchor href={APPLICATIONS_FAQ_URL}>We have answers</Anchor>
            </List.Item>
          </List.Root>
          <Box>
            <Button asChild tone="brand" emphasis="filled">
              <a href={getExternalUrl(EXTERNAL_URLS.RENTALS_SEARCH_PAGE_URL)}>View all rentals</a>
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
